import {
  formatDate,
  getFirstWednesdayForMonth,
  getUpcomingWednesday,
  nextWednesday,
  previousWednesday,
  shiftIsoMonth,
  weekdayLabel,
} from '../lib/dates';

export function MonthWednesdayStepper({
  date,
  onChange,
  className = '',
  ariaLabel = 'Mittwoch und Monat wechseln',
}: {
  date: string;
  onChange: (nextIsoDate: string) => void;
  className?: string;
  ariaLabel?: string;
}) {
  const month = date.slice(0, 7);

  return (
    <div className={`mw-stepper-group ${className}`.trim()}>
      <p className="plan-date-label mw-stepper-date">
        <span>{weekdayLabel(date)}</span>
        <strong>{formatDate(date)}</strong>
      </p>
      <div className="mw-stepper" role="group" aria-label={ariaLabel}>
        <button
          type="button"
          className="mw-stepper-step mw-stepper-outer"
          aria-label="Vorheriger Monat"
          onClick={() =>
            onChange(getFirstWednesdayForMonth(shiftIsoMonth(month, -1)))
          }
        >
          «
        </button>
        <button
          type="button"
          className="mw-stepper-step"
          aria-label="Vorheriger Mittwoch"
          onClick={() => onChange(previousWednesday(date))}
        >
          ‹
        </button>
        <button
          type="button"
          className="mw-stepper-label mw-stepper-now"
          aria-label="Zum nächsten Mittwoch springen"
          onClick={() => onChange(getUpcomingWednesday(new Date()))}
        >
          Heute
        </button>
        <button
          type="button"
          className="mw-stepper-step"
          aria-label="Nächster Mittwoch"
          onClick={() => onChange(nextWednesday(date))}
        >
          ›
        </button>
        <button
          type="button"
          className="mw-stepper-step mw-stepper-outer"
          aria-label="Nächster Monat"
          onClick={() =>
            onChange(getFirstWednesdayForMonth(shiftIsoMonth(month, 1)))
          }
        >
          »
        </button>
      </div>
    </div>
  );
}
